export const config = {
  serverURL: "https://api-auto02.apps.mktnxt.com/api/v1.0",
  NXTServerURL: "https://{tenant}.mediascape-auto02.apps.mktnxt.com",
  gaTrackingId: "UA-39909867-5",
  gaDebug: false,
  environment: "auto02",
  clientId: "dl4ml3b5f2gjp2qaoj0c06pql",
  cognitoDomain: "duplo-nonprod.auth.us-east-1.amazoncognito.com",
  identityProvider: "duplo-nonprod",
  launchDarklyClientId: "5da4c4dddc79f008b44ff6d6",
  uploadCreativeServerUrl: "https://radigio-alb-qa4.mediascape-dev.com/creative/api/v1.0/creatives",
  userPoolId: "us-east-1_aCLCffalK",
};